"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SharpnessSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15.5,5 C15.9106221,5 16.1062896,5.44759748 15.9460918,5.72583763 L9.40533961,14.7927453 C9.23310852,15.03508 8.81912231,15.0943909 8.59466039,14.7927453 L2.09466039,5.79274528 C1.88432312,5.51269531 2.03538513,5 2.5,5 L15.5,5 Z M14.5221221,6 L3.47787787,6 L9,13.6460153 L14.5221221,6 Z M12.5,7 L9,12 L9,7 L12.5,7 Z" })));
};
SharpnessSmall.displayName = 'SharpnessSmall';
exports.default = SharpnessSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SharpnessSmall.js.map